import axios from "axios";
import ErrorParser from '../error.parser';

const VerifyService = {
  networks: async function () {
    const requestData = {
      method: "get",
      url: "/api/qualitycontrol/verify/networks",
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  datasets: async function (networkid, year) {
    const requestData = {
      method: "post",
      url: "/api/qualitycontrol/verify/datasets",
      data: {
        network_id: networkid,
        year: year
      }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  verify: async function (month, year, id) {
    const requestData = {
      method: "post",
      url: "/api/qualitycontrol/verify/verify",
      data: {
        month: month,
        year: year,
        id: id
      }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  },
  undo: async function (month, year, id) {
    const requestData = {
      method: "post",
      url: "/api/qualitycontrol/verify/undo",
      data: {
        month: month,
        year: year,
        id: id,
      }
    };
    try {
      const response = await axios(requestData);
      return response.data;
    } catch (error) {
      const message = ErrorParser.asMessage(error);
      throw new Error(message);
    }
  }
};

export default VerifyService;
